// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"webhooks_tabHeader_1uwFAo4","tabTitle":"webhooks_tabTitle_2Npl535"};